import React from 'react'

import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { useSettingsStore } from '@/store/settings.store'
import { createRTLClassName } from '@/lib/rtl'

interface AppLayoutProps {
  children: React.ReactNode
}

/**
 * Responsive app layout with mobile-first sidebar for both LTR and RTL
 */
export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { direction } = useSettingsStore()

  const layoutClasses = createRTLClassName({
    common: 'min-h-screen',
    ltr: 'flex',
    rtl: 'flex flex-row-reverse',
  })

  const mainClasses = createRTLClassName({
    common: 'flex-1 flex flex-col transition-all duration-300 min-w-0', // min-w-0 prevents overflow
    ltr: 'lg:ml-72',
    rtl: 'lg:mr-72',
  })

  return (
    <div className={layoutClasses} dir={direction}>
      {/* Sidebar - Hidden on mobile, fixed on desktop */}
      <Sidebar />

      {/* Main Content Area */}
      <div className={mainClasses}>
        {/* Top Navigation Bar */}
        <Topbar />

        {/* Page Content - Full stretch without container */}
        <main className="flex-1 overflow-x-hidden">
          {children}
        </main>
      </div>
    </div>
  )
} 